import {AOsApi} from '@/classes/app/api/os/a-os-api';

export class Index extends AOsApi {
  protected _url: string = '/';
}
